/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Class used to represent a transaction
 */
export type TransactionBaseDTO = {
  /**
   * Creation date
   */
  createdAt?: string;
  /**
   * Currency used in the transaction
   */
  currency?: string;
  /**
   * Account balance after transaction being completed
   */
  currentAccountBalance?: number;
  /**
   * Description associated with transaction
   */
  description?: string;
  /**
   * Indicates which payment method was used in the transaction.
   */
  paymentMethod?: TransactionBaseDTO.paymentMethod;
  /**
   * TerminalID associated with this transaction if payment is made by POS
   */
  terminalId?: string;
  /**
   * Amount involved in the transaction
   */
  totalAmount?: number;
  /**
   * Indicates the transaction id saved in external service
   */
  transactionId?: string;
  /**
   * Indicates if the money is flowing IN or OUT of the merchant account
   */
  transactionType?: TransactionBaseDTO.transactionType;
};

export namespace TransactionBaseDTO {
  /**
   * Indicates which payment method was used in the transaction.
   */
  export enum paymentMethod {
    USSD = "USSD",
    QR_CODE = "QR_CODE",
    IN_BANK_TRANSFER = "IN_BANK_TRANSFER",
    MOMO = "MOMO",
    OUT_BANK_TRANSFER = "OUT_BANK_TRANSFER",
    REFUND = "REFUND",
    PAYMENT_LINK_CARD = "PAYMENT_LINK_CARD",
    PAYMENT_LINK_USSD = "PAYMENT_LINK_USSD",
    PAYMENT_LINK_QR_CODE = "PAYMENT_LINK_QR_CODE",
    PAYMENT_LINK_BANK_TRANSFER = "PAYMENT_LINK_BANK_TRANSFER",
    STAMP_DUTY = "STAMP_DUTY",
    POS = "POS",
    TRANSACTION_CHARGE = "TRANSACTION_CHARGE",
  }

  /**
   * Indicates if the money is flowing IN or OUT of the merchant account
   */
  export enum transactionType {
    IN = "IN",
    OUT = "OUT",
  }
}
